import React from "react";
import styles from "./LoadingRoller.module.scss";
const LoadingRoller = () => {
    return (React.createElement("div", { className: styles.roller },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
};
export default LoadingRoller;
//# sourceMappingURL=LoadingRoller.js.map